import { Action, State, StateContext } from '@ngxs/store';

import * as LoginActions from './login.actions';
import { UserModel } from './login.model';

@State<UserModel>({
  name: 'user',
  defaults: {
    refresh_token: '',
    session_expires_at: '',
    session_key: '',
    session_scope: ''
  }
})
export class LoginState {
  @Action(LoginActions.LoginUser)
  LoginUser(
    { getState, setState }: StateContext<UserModel>,
    { payload }: LoginActions.LoginUser
  ) {
    setState({ ...getState(), ...payload });
  }
  LogoutUser(
    { getState, setState }: StateContext<UserModel>,
    { payload }: LoginActions.LogoutUser
  ) {
    setState({ ...getState(), ...payload });
  }
}
